import React, { useMemo } from 'react';

import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import MoonLoader from 'react-spinners/ClipLoader';
import SeatRecline from '../shared/SeatRecline';
import { showModal, setActiveWidget } from '../../redux/actions';
import UpsellSummary from '../shared/UpsellSumary';
import { getSeatTriggerSubtitle } from '../../utils/trigger';
import { FormattedMessage } from 'react-intl';
import { getTriggerStyles, getTriggerButtonStyles } from '../../themes/utils';

const Trigger = ({
  seats,
  flights,
  showModal,
  hasSeats,
  setActiveWidget,
  textOverrides,
  theme,
}) => {
  const triggerSubtitle = getSeatTriggerSubtitle(hasSeats, textOverrides);
  const subtitle = triggerSubtitle.includes('seat_load_') ? (
    <FormattedMessage
      id={triggerSubtitle}
      defaultMessage={triggerSubtitle
        .replace('seat_load_', '')
        .replace('_', ' ')}
    />
  ) : (
    triggerSubtitle
  );

  const buttonStyles = getTriggerButtonStyles(theme, 'seatMapTrigger');
  const sectionStyles = getTriggerStyles(theme, 'seatMapTrigger');

  const hasSeatsSelected = useMemo(() => {
    return seats.some((seat) => seat.name);
  }, [seats]);

  return (
    <section
      className="gr-block sm:gr-flex gr-flex-col gr-box-border"
      style={sectionStyles}
    >
      <div className="gr-flex gr-flex-col sm:gr-flex-row gr-gap-4 gr-p-6">
        <div className="g-flex-1">
          <div className="gr-flex gr-gap-4">
            <SeatRecline />
            <div className="gr-flex gr-flex-col gr-pt-1 gr-gap-3">
              <h3 className="gr-m-0 gr-text-primary">
                <FormattedMessage
                  id="seat_selection"
                  defaultMessage="Seat Selection"
                />
              </h3>
              <div className="gr-flex gr-flex-col gr-gap-3">
                {!theme?.seatMapTrigger?.upsellSummary?.enabled &&
                seats?.length > 0 ? (
                  seats?.map(
                    ({
                      name = '',
                      seat = '',
                      first_names = '',
                      surname = '',
                    }) => {
                      const paxName = `${first_names} ${surname}`;
                      const [, flightNumber] = name.split(', ');
                      return (
                        <span className="gr-text-gray-600" key={uuidv4}>
                          {flightNumber
                            ? flightNumber.replaceAll(' ', '') + ' - '
                            : ''}
                          {paxName}: {seat}
                        </span>
                      );
                    }
                  )
                ) : (
                  <p className="gr-text-gray-600">{subtitle}</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          id="gordian-select-seat-button-container"
          className="gr-flex-1 gr-flex gr-items-center sm:gr-justify-end gr-justify-center gr-w-full sm:gr-w-full  gr-overflow-auto"
        >
          {hasSeats ? (
            <button
              disabled={!(flights?.length > 0)}
              onClick={() => {
                showModal(true);
                setActiveWidget('seatmap');
              }}
              id="gordian-seat-selection"
              className="gr-text-center"
              style={buttonStyles}
            >
              {flights?.length > 0 || process.env.STORYBOOK_USED ? (
                <FormattedMessage
                  id="select_seat"
                  defaultMessage="Select Seat"
                />
              ) : (
                <MoonLoader size={25} color={'white'} />
              )}
            </button>
          ) : null}
        </div>
      </div>
      {hasSeatsSelected && <UpsellSummary trigger="seat" />}
    </section>
  );
};

const mapStateToProps = (state) => ({
  seats: state.basket.seats,
  hasSeats: state.session.hasSeats,
  flights: state.itinerary.flights,
  textOverrides: state.session.textOverrides,
  theme: state.session.theme,
});

const mapDispatchToProps = {
  showModal,
  setActiveWidget,
};

export default connect(mapStateToProps, mapDispatchToProps)(Trigger);
